import { More } from '@wix/wix-ui-icons-common/on-stage';
import React, { forwardRef, useState } from 'react';
import { IconButton } from '@wix/wix-ui-tpa/cssVars';
import { classes } from '../../../../TableWrapper/ItemsWrapper/Item/ItemActions/ItemActions.st.css';
import withClickOutsideListener from '../../../../../../../Shared/HOC/withClickOutsideListener';
import { ItemActionsMenuMobile } from './ItemActionsMenuMobile';
import MoveWrapper from '../../../../../../Shared/MoveWrapper/MoveWrapper';

const MobileActionsMenuTop = forwardRef((props: any, ref: any) => {
  const { open, setOpen } = props;
  const [showMenu, setShowMenu] = useState({
    showMenu: false,
    showMove: false,
  });
  const handleOnClick = () => {
    setOpen(!open);
    setShowMenu((prevState: any) => ({
      ...prevState,
      showMenu: !open,
      showMove: false,
    }));
  };
  const handleOpenMove = () => {
    setShowMenu((prevState: any) => ({
      ...prevState,
      showMenu: false,
      showMove: true,
    }));
  };
  const handleOnCloseMove = () => {
    setShowMenu((prevState: any) => ({
      ...prevState,
      showMenu: false,
      showMove: false,
    }));
  };
  return (
    <div ref={ref}>
      <IconButton
        className={classes.iconButton}
        icon={<More />}
        onClick={handleOnClick}
      />

      {open && (
        <div>
          {showMenu.showMenu && (
            <ItemActionsMenuMobile
              setOpen={setOpen}
              open={open}
              handleOpenMove={handleOpenMove}
            />
          )}
          {showMenu.showMove && (
            <MoveWrapper handleOnCloseMove={handleOnCloseMove} />
          )}
        </div>
      )}
    </div>
  );
});
export default withClickOutsideListener(MobileActionsMenuTop);
